import {get} from "lodash"
import {REHYDRATE} from "redux-persist/constants"
import {ADD, CLEAR} from "./actions"
import {DEFAULT_LANG} from "../helpers/getSupportedLocale"

export default (state = {currentLocale: DEFAULT_LANG}, action) => {
  const {bucketName, data, locale} = action
  switch (action.type) {
    case REHYDRATE:
      return rehydrate(state, action)
    case ADD:
      return add(state, bucketName, locale, data)
    case CLEAR:
      return {}
    default:
      return state
  }
}

function add(state, bucketName, locale, data) {
  const {etag, Etag, load, ...keys} = data
  return {
    ...state,
    currentLocale: locale,
    [bucketName]: data,
    messages: {...state.messages, ...keys}
  }
}

/** @author: Richard Scoones 28/8/18
 *  @desc: We only want to restore `currentLocale` and `messages` from redux-persist. Buckets are used for inline loading.
 */
function rehydrate(state, action) {
  const persistedLang = get(action.payload, "lang") || {}
  const {currentLocale, messages} = persistedLang

  return {
    ...state,
    currentLocale,
    messages
  }
}
